import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AgendaSigningRepository } from '../domain/repository/agenda-signing.repository';
import { AGENDA_SIGNING_REPOSITORY } from './agenda-signing.tokens';

@Injectable()
export class RescheduleReservationUseCase {
  constructor(@Inject(AGENDA_SIGNING_REPOSITORY) private readonly repository: AgendaSigningRepository) { }

  execute(reservationId: string, newDate: string): Observable<any> {
    return this.repository.rescheduleReservation(reservationId, newDate);
  }
}
